// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Stroke_wrap_1By1x","input":"Stroke_input_2GBHQ","select":"Stroke_select_OOSjp","selectItem":"Stroke_selectItem_3IMrK","toolColor":"Stroke_toolColor_I99Wm"};